import { Manifestation } from "../../../core/utils/types/entities";

export default {
  divideManifestationsByMaterialType: {
    manifestations: [
      {
        pid: "870970-basis:44504928",
        genreAndForm: ["noveller"],
        source: ["Bibliotekskatalog"],
        languages: {
          main: [
            {
              display: "engelsk",
              isoCode: "eng"
            }
          ],
          notes: []
        },
        titles: {
          main: ["I, Robot (Ved Tricia Reilly)"],
          original: []
        },
        fictionNonfiction: {
          display: "skønlitteratur",
          code: "FICTION"
        },
        materialTypes: [
          {
            materialTypeSpecific: {
              display: "lydoptagelse (cd)"
            }
          },
          {
            materialTypeSpecific: {
              display: "bog"
            }
          }
        ],
        creators: [
          {
            display: "Isaac Asimov",
            __typename: "Person",
            nameSort: "Asimov, Isaac"
          },
          {
            display: "Tricia Reilly",
            __typename: "Person"
          }
        ],
        publisher: ["Macmillan"],
        identifiers: [
          {
            value: "9780230026810"
          },
          {
            value: "9780230026827"
          }
        ],
        contributors: [],
        edition: {
          summary: "2008",
          publicationYear: {
            display: "2008"
          }
        },
        dateFirstEdition: {
          display: "1950",
          year: 1950
        },
        audience: {
          generalAudience: [],
          ages: [],
          childrenOrAdults: []
        },
        notes: [
          {
            display: ["Bogens originaludgave: 1950"]
          }
        ],
        physicalDescription: {
          summaryFull: "2 cd'er 1 bog 95 sider: ill. 2t., 31 min.",
          numberOfPages: 95,
          playingTime: "2t., 31 min."
        },
        hostPublication: null,
        manifestationParts: null,
        accessTypes: [
          {
            code: "PHYSICAL"
          }
        ],
        access: [
          {
            __typename: "InterLibraryLoan",
            loanIsPossible: true
          }
        ],
        shelfmark: {
          postfix: "Asimov",
          shelfmark: "83.8"
        },
        workYear: {
          year: 1950
        },
        catalogueCodes: {
          nationalBibliography: [],
          otherCatalogues: []
        }
      },
      {
        pid: "150061-ebog:ODN0000039136",
        genreAndForm: [],
        source: ["eReolen Global"],
        languages: {
          main: [
            {
              display: "engelsk",
              isoCode: "eng"
            }
          ],
          notes: []
        },
        titles: {
          main: ["I, Robot"],
          original: []
        },
        fictionNonfiction: {
          display: "skønlitteratur",
          code: "FICTION"
        },
        materialTypes: [
          {
            materialTypeSpecific: {
              display: "e-bog"
            }
          }
        ],
        creators: [
          {
            display: "Isaac Asimov",
            __typename: "Person",
            nameSort: "Asimov, Isaac"
          }
        ],
        publisher: [],
        identifiers: [
          {
            value: "9780553900330"
          }
        ],
        contributors: [],
        edition: {
          summary: "2004",
          publicationYear: {
            display: "2004"
          }
        },
        dateFirstEdition: null,
        audience: {
          generalAudience: [
            "Text Difficulty 3 - Text Difficulty 5",
            "UG/Upper grades (9th-12)",
            "820. Lexile",
            "6.1. ATOS Level"
          ],
          ages: [],
          childrenOrAdults: []
        },
        notes: [
          {
            display: [
              "Electronic reproduction. New York : Spectra, 2004. Requires the Libby app or a modern web browser"
            ]
          }
        ],
        physicalDescription: {
          summaryFull: "1 online resource",
          numberOfPages: null,
          playingTime: null
        },
        hostPublication: null,
        manifestationParts: null,
        accessTypes: [
          {
            code: "ONLINE"
          }
        ],
        access: [
          {
            __typename: "AccessUrl",
            origin: "link.overdrive.com",
            url: "http://link.overdrive.com/?websiteID=100515&titleID=39136",
            loginRequired: false
          }
        ],
        shelfmark: null,
        workYear: null,
        catalogueCodes: {
          nationalBibliography: [],
          otherCatalogues: []
        }
      },
      {
        pid: "150061-netlydbog:ODN0000105225",
        genreAndForm: [],
        source: ["eReolen Global"],
        languages: {
          main: [
            {
              display: "engelsk",
              isoCode: "eng"
            }
          ],
          notes: []
        },
        titles: {
          main: ["I, Robot"],
          original: []
        },
        fictionNonfiction: {
          display: "vides ikke",
          code: "NOT_SPECIFIED"
        },
        materialTypes: [
          {
            materialTypeSpecific: {
              display: "lydbog (online)"
            }
          }
        ],
        creators: [
          {
            display: "Isaac Asimov",
            __typename: "Person",
            nameSort: "Asimov, Isaac"
          },
          {
            display: "Scott Brick",
            __typename: "Person"
          }
        ],
        publisher: ["Random House Audio"],
        identifiers: [
          {
            value: "9780739346273"
          }
        ],
        contributors: [],
        edition: {
          summary: "Unabridged, 2004",
          publicationYear: {
            display: "2004"
          }
        },
        dateFirstEdition: null,
        audience: {
          generalAudience: [
            "Text Difficulty 3 - Text Difficulty 4",
            "820. Lexile"
          ],
          ages: [],
          childrenOrAdults: []
        },
        notes: [
          {
            display: ["Unabridged"]
          }
        ],
        physicalDescription: {
          summaryFull: "1 online resource (7 audio files) digital",
          numberOfPages: null,
          playingTime: null
        },
        hostPublication: null,
        manifestationParts: null,
        accessTypes: [
          {
            code: "ONLINE"
          }
        ],
        access: [
          {
            __typename: "AccessUrl",
            origin: "link.overdrive.com",
            url: "http://link.overdrive.com/?websiteID=100515&titleID=105225",
            loginRequired: false
          }
        ],
        shelfmark: null,
        workYear: null,
        catalogueCodes: {
          nationalBibliography: [],
          otherCatalogues: []
        }
      },
      {
        pid: "870970-basis:23798255",
        genreAndForm: ["noveller"],
        source: ["Bibliotekskatalog"],
        languages: {
          main: [
            {
              display: "engelsk",
              isoCode: "eng"
            }
          ],
          notes: []
        },
        titles: {
          main: ["I, Robot (Oxford bookworms library, ved Rowena Akinyemi)"],
          original: []
        },
        fictionNonfiction: {
          display: "skønlitteratur",
          code: "FICTION"
        },
        materialTypes: [
          {
            materialTypeSpecific: {
              display: "bog"
            }
          }
        ],
        creators: [
          {
            display: "Isaac Asimov",
            __typename: "Person",
            nameSort: "Asimov, Isaac"
          }
        ],
        publisher: ["Oxford University Press"],
        identifiers: [
          {
            value: "0-19-423069-4"
          }
        ],
        contributors: [],
        edition: {
          summary: "2. edition, 2000",
          publicationYear: {
            display: "2000"
          }
        },
        dateFirstEdition: null,
        audience: {
          generalAudience: [],
          ages: [],
          childrenOrAdults: []
        },
        notes: [],
        physicalDescription: {
          summaryFull: "104 sider: ill.",
          numberOfPages: 104
        },
        hostPublication: null,
        manifestationParts: null,
        accessTypes: [
          {
            code: "PHYSICAL"
          }
        ],
        access: [
          {
            __typename: "InterLibraryLoan",
            loanIsPossible: true
          }
        ],
        shelfmark: {
          postfix: "Asimov",
          shelfmark: "83.8"
        },
        workYear: null,
        catalogueCodes: {
          nationalBibliography: [],
          otherCatalogues: []
        }
      }
    ] as Manifestation[]
  }
};
